import { isShippingQuoteUnavailable } from '@/lib/functions/isShippingQuoteUnavailable';

import type { OrderPayload } from '@/lib/types/orderPayload';

/**
 * True when the order has a shipping method and/or a quoted shipping total.
 * Method assignment alone is enough for cart estimate success; pricing can lag FedEx re-quote.
 */
export function orderHasShippingEstimate(order: OrderPayload | null | undefined): boolean {
  if (!order) {
    return false;
  }

  const shipping = order.pricing?.shipping;

  if (isShippingQuoteUnavailable(shipping)) {
    return false;
  }

  if (order.shipments?.[0]?.method) {
    return true;
  }

  if (typeof shipping === 'number' && shipping >= 0) {
    return true;
  }

  return order.states?.order !== 'cart' && typeof shipping === 'number';
}
